export const types = {
  TOKEN_GET_REQUEST: 'funpoint/TOKEN_GET_REQUEST',
  TOKEN_GET_COMPLETED: 'funpoint/TOKEN_GET_COMPLETED',
  TOKEN_GET_FAILED: 'funpoint/TOKEN_GET_FAILED',
  
  CARD_GET_REQUEST: 'funpoint/CARD_GET_REQUEST',
  CARD_GET_COMPLETED: 'funpoint/CARD_GET_COMPLETED',
  CARD_GET_FAILED: 'funpoint/CARD_GET_FAILED',
  
  CARD_ADD_REQUEST: 'funpoint/CARD_ADD_REQUEST',
  CARD_ADD_COMPLETED: 'funpoint/CARD_ADD_COMPLETED',
  CARD_ADD_FAILED: 'funpoint/CARD_ADD_FAILED',

  CARD_REMOVE_REQUEST: 'funpoint/CARD_REMOVE_REQUEST',
  CARD_REMOVE_COMPLETED: 'funpoint/CARD_REMOVE_COMPLETED',
  CARD_REMOVE_FAILED: 'funpoint/CARD_REMOVE_FAILED',
}

const initialState = {
  card_bound: null,
  form_token: null, // For FunPoint card form
  card_token: null, // For FunPoint card 3D Secure
  three_d_url: null, // For FunPoint card 3D Secure
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.TOKEN_GET_REQUEST:
    case types.TOKEN_GET_FAILED:
    case types.CARD_GET_REQUEST:
    case types.CARD_GET_FAILED:
    case types.CARD_ADD_REQUEST:
    case types.CARD_ADD_FAILED:
    case types.CARD_REMOVE_REQUEST:
    case types.CARD_REMOVE_FAILED:
      return { ...state };

    case types.TOKEN_GET_COMPLETED:
      return { ...state, form_token: action.data.token_data };

    case types.CARD_GET_COMPLETED:
      let cardBound = state.card_bound;
      
      if (action.data.BindCardList.length > 0) { cardBound = action.data.BindCardList[0]; }
      
      return { ...state, card_bound: cardBound };

    case types.CARD_ADD_COMPLETED:
      return { ...state, three_d_url: action.data.redirect_url };
    
    case types.CARD_REMOVE_COMPLETED:
      return { ...state, card_bound: null };

    default: return state;
  }
}

export const actions = {
  getFunPointTokenRequest: () => ({
    type: types.TOKEN_GET_REQUEST,
  }),
  getFunPointTokenCompleted: (data) => ({
    type: types.TOKEN_GET_COMPLETED,
    data: data,
  }),
  getFunPointTokenFailed: (error) => ({
    type: types.TOKEN_GET_FAILED,
    error: error,
  }),
  getFunPointCardRequest: () => ({
    type: types.CARD_GET_REQUEST,
  }),
  getFunPointCardCompleted: (data) => ({
    type: types.CARD_GET_COMPLETED,
    data: data,
  }),
  getFunPointCardFailed: (error) => ({
    type: types.CARD_GET_FAILED,
    error: error,
  }),
  addFunPointCardRequest: (data) => ({
    type: types.CARD_ADD_REQUEST,
    data: data,
  }),
  addFunPointCardCompleted: (data) => ({
    type: types.CARD_ADD_COMPLETED,
    data: data,
  }),
  addFunPointCardFailed: (error) => ({
    type: types.CARD_ADD_FAILED,
    error: error,
  }),
  removeFunPointCardRequest: (data) => ({
    type: types.CARD_REMOVE_REQUEST,
    data: data,
  }),
  removeFunPointCardCompleted: () => ({ type: types.CARD_REMOVE_COMPLETED }),
  removeFunPointCardFailed: (error) => ({
    type: types.CARD_REMOVE_FAILED,
    error: error,
  }),
}
